module.exports = __webpack_public_path__ + "static/img/1-04-3.6551093.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/1-04-3.png
// module id = N/j1
// module chunks = 1